import { Pagination, PaginationItem } from "@mui/material";
import { DisplayParms } from "../types/classes/DisplayParms";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

//This function creates pagination for nicu.
export function NicuPagination(props: {pageCount: number, displayParms: DisplayParms, onPageChange: (displayParms: DisplayParms) => void}) {

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        let newDisplayParms: DisplayParms = new DisplayParms();
        newDisplayParms.Page = value;
        newDisplayParms.ResetShowFlag = true;
        props.onPageChange(newDisplayParms);
    };

    return (
        <Pagination size="medium" count={props.pageCount} page={props.displayParms.Page} onChange={handleChange} variant="outlined" 
            shape="rounded" showFirstButton showLastButton
            renderItem={(item) => (
                <PaginationItem
                    components={{ 
                        first: KeyboardDoubleArrowLeftIcon,
                        last: KeyboardDoubleArrowRightIcon
                    }}
                    {...item}
                />
            )}
        />
    );
}